import { createFileRoute } from "@tanstack/react-router";

// Rendered by the root route outside the gate.
export const Route = createFileRoute("/sso-callback")({ component: () => null });
